import React from "react";

export const Airports = [
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">Grenzen verleggen in de luchtvaart</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/Grenzen verleggen in de luchtvaart.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
        <img src="images/qr/qr-airport-success-story-video-01.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">
      Bitumen FreshAir op Rotterdam The Hague Airport
    </h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/Bitumen FreshAir op Rotterdam The Hague Airport.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-airport-success-story-video-02.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">
      KLM Equipment Services over op Shell GTL Fuel
    </h4>
    <div className="slideText">
      <p>
        Schiphol Amsterdam Airport is de derde grootste luchthaven van Europa.
        24 uur per dag, zeven dagen per week rijden er circa vierduizend
        grondvoertuigen rond om alles goed te laten verlopen. Al deze voertuigen
        – waarvan KLM 60% bezit – hebben brandstof nodig. Dagelijks komt dit
        neer op 30.000 liter, wat op jaarbasis oploopt tot zo’n 10 miljoen liter
        brandstof. In juni 2019 stapte de operationele vloot op Schiphol over op
        Shell GTL Fuel.
      </p>
      <p>
        GTL (gas-to-liquid) is een vloeibare brandstof gemaakt van aardgas. GTL
        verbrandt schoner dan conventionele diesel en produceert daardoor lagere
        uitstoot van lokale emissies. Omdat er op de platforms veel
        dieselvoertuigen stationair draaiden op een klein oppervlakte, was er
        overlast van rook en roet. “De lokale luchtkwaliteit is flink verbeterd,
        en daarmee het welzijn van ons personeel”, zegt Gerwin Te Hennepe van
        KLM Equipment Services. Daarnaast is het probleem van het dichtslibben
        van roetfilters van dieselmotoren met GTL opgelost. KLM en Schiphol
        streven naar een CO₂-neutrale bedrijfsvoering aan de ‘platformzijde’ in
        2030.
      </p>
    </div>
    <div className="slideImage">
      <img
        src="images/065e0570-a380-4000-81ed-dbdc730ae02c-cropped.jpg"
        alt=""
        width="560"
        height="auto"
      />
    </div>
  </div>,
  <>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <p class="statsIntro">
          <strong>
            ''GTL zorgt ervoor dat we vandaag de dag al wat kunnen doen aan de
            lokale emissie. We beschouwen het als een echte transitiebrandstof.
            Op de lange termijn is het streven om de vloot verder te
            verduurzamen en te elektrificeren. Maar die stappen kosten tijd’’
          </strong>
          <br />
          <br />
          Gerwin te Hennepe (KLM Equipment Services)
        </p>
      </div>
      <div className="colRight col50 solidColourContainer stats">
        <div class="d-flex">
          <p className="figureContainer">
            <span className="figure">10.000.000</span>
            <br />
            liter brandstof / jaar
          </p>
        </div>
      </div>
    </div>
  </>,
];
